import { useSelector } from '@bridebook/web/lib/utils';
import { getWeddingProfileId } from '@bridebook/web/lib/weddings/selectors';
import { BUCKETS } from '@bridebook/ui';

export const useWebsitePhotoUploaderConfig = () => {
  const weddingId = useSelector(getWeddingProfileId);
  const directory = `wedding-websites/uploads/${weddingId}`;

  return {
    accept: ['image/jpeg', 'image/png', 'image/webp', 'image/avif'],
    region: '',
    bucket: BUCKETS.media,
    directory,
    defaultValidatorConfig: {
      maxSize: 10,
      maxWidth: 8000,
      maxHeight: 8000,
      minWidth: 600,
      minHeight: 600,
    },
  };
};

export const isPhotoEmpty = (photo: { path: string } | undefined) => !photo || photo.path === '';
